import { render, staticRenderFns } from "./BookingPlanItem.vue?vue&type=template&id=07705842&scoped=true&"
import script from "./BookingPlanItem.vue?vue&type=script&lang=js&"
export * from "./BookingPlanItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07705842",
  null
  
)

export default component.exports